import { requests } from '@/libs/axios/axios'
import { LicenseEndpoints } from '../license-endpoints'
import { EditLicenseData } from '../license.interfaces'

async function generateLicense(license: EditLicenseData) {
  return requests.post(`${LicenseEndpoints.LICENSE}`, license)
}

export default generateLicense
